import IconFacebook from '../components/icons/svg/FacebookIcon';
import InstagramIcon from '../components/icons/svg/InstagramIcon';
import LinkedInIcon from '../components/icons/svg/LinkedInIcon';
import WechatIcon from '../components/icons/svg/WeChatIcon';
import XIcon from '../components/icons/svg/XIcon';
import getEnv from '../env';

const env = getEnv();

export const BUILDINGS_PAGE_LIMIT = 30;
export const CLAIMS_FORM_COMMENT_MAX_LENGTH = 800;
export const LOGOUT_REDIRECT_URI_KEY = 'redirection_url';

export const routes = {
  // public routes
  brokerInvite: '/broker-signup',
  numberUnitsOwned: '/units-owned',
  welcome: '/welcome',
  registerEmail: '/email-registration',
  checkEmail: '/email-confirmation',
  emailSuccess: '/email-finish',
  error500: '/*',
  limitation: '/limitation',
  thankYou: '/thank-you',

  // private routes
  home: '/',
  test: '/test',
  enroll: '/enroll',
  propertyEnrollmentForm: '/enroll/property-form',
  propertyEnrollConfirm: '/enroll/confirmation',
  enrollNotEligible: '/enroll-not-eligible',
  myProperties: '/my-properties',
  unitsOwnedEnroll: '/units-owned-enroll',
  renterInvite: '/renter-invite',
  renterInviteConfirmation: '/renter-invite/confirmation',
  dealsDashboard: '/application-tracker',
  dealsDashboardRedirectLink: '/deals-dashboard',
  rentersInsurance: '/renters-insurance',
  claimsReport: '/track-claims',
  claimsFormInstructions: '/claims/instructions',
  claimsThankYou: '/claims/thank-you',
  claimsForm: '/claims/form',
  users: '/users',
  createUser: '/users/create',
  userDetails: '/users/:userId',
  userPropertiesAssignment: '/users/:userId/properties',
};

export const apiUri = {
  //private
  getMe: 'v1/me',
  meProperties: 'v1/me/properties',

  addProperty: 'v1/properties/add',
  updateUserInfo: 'v1/me/update',
  updateUserStatus: 'v1/me/update-status',
  updateRenterInviteType: 'v1/me/update-renter-invite-type',
  buildingsList: 'v1/buildings',
  addressesList: 'v1/me/addresses',
  inviteRenter: 'v1/renter/invite',
  sendWelcomeEmail: 'v1/users/{userId}/send-welcome-email',

  getUsersList: 'v1/users/search',
  userGet: 'v1/users/{userId}',
  userUpdate: 'v1/users/{userId}',
  userCreate: 'v1/users',
  userProperties: 'v1/users/{userId}/properties',

  applicationsList: 'v1/deals/{landlordId}',

  getCorePermissions: '/v1/permissions/core',
  getPermissions: '/v1/permissions',

  // ==== ZGRI Endpoints ==== //
  // @deprecated It is replaced by the new ZGRI endpoints
  listRiApplications: 'v1/ri/applications',
  // @deprecated It is replaced by the new ZGRI endpoints
  getRiApplication: (applicationId: string) => `v1/ri/applications/${applicationId}`,
  zgriGetRenter: (renterId: string) => `/v1/zgri/renters/${renterId}`,
  zgriListRenters: '/v1/zgri/renters',
  zgriExportRenters: '/v1/zgri/renters/export',

  getPropertyList: '/v1/properties/list/landlord',
  companyPropertiesSearch: 'v1/users/{userId}/properties/search',
  assignableProperties: 'v1/properties/assignable',

  claimsEmbedData: 'v1/claims/embed-data',

  getClaimDeals: 'v1/deals',
  createClaim: 'v1/claims',
  uploadClaimDocument: (claimAlphaId: string, submissionAlphaId: string) =>
    `v1/claims/${claimAlphaId}/submissions/${submissionAlphaId}/documents`,
  deleteClaimDocument: (claimAlphaId: string, submissionAlphaId: string, documentAlphaId: string) =>
    `v1/claims/${claimAlphaId}/submissions/${submissionAlphaId}/documents/${documentAlphaId}`,
  submitClaimSubmission: (claimAlphaId: string, submissionAlphaId: string) =>
    `v1/claims/${claimAlphaId}/submissions/${submissionAlphaId}`,
  // legacy claims endpoints below
  createClaimSubmission: 'v1/submissions',
  uploadDocument: 'v1/documents/upload',
  deleteDocument: (id: string) => `v1/documents/${id}`,
  updateClaimSubmission: (submissionId: string) => `v1/submissions/${submissionId}`,

  // public
  register: 'public/me/register',
  registerBroker: 'public/me/broker-signup',
  resendEmail: 'public/me/resend-verification-email',
  getFeatureFlags: 'public/feature-flags',
  emailValidation: 'public/email/validate',
  trackAnalytics: 'public/t',

  getAllDeals: '/v1/landlord/deals',
  getAllDealsRecordsCount: '/v1/landlord/deals/amount',
  getAllDealsExport: '/v1/landlord/deals/export',
  getLandlordBuildings: '/v1/landlord/buildings',
  getDealBondDocument: '/v1/landlord/deal/{dealId}/document',
  getDetailedDealDocument: '/v1/landlord/deals/details/{dealId}',
  submitLeaseDetails: '/v1/lease-details',
  getPropertyCoverages: '/v1/properties/{propertyId}/coverages',
};

export const externalConnections = {
  dashboard: env.legacyLLPEndpoint,
  invite: `${env.legacyLLPEndpoint}/invite`,
  signin: env.login + 'sign-in',
  logout: env.login + 'logout',
  refreshTokenUrl: env.login_api + 'v1/token/refresh',
  loginApiLogout: env.login_api + 'v1/logout',
};

const hubspot = env.hubspot_form_api_url;
const hubspotPortal = env.hubspot_portal_id;
export const hubspotSMBURL = hubspot + `${hubspotPortal}/${env.hubspot_smb_id}`;
export const hubspotEnterpriseURL = hubspot + `${hubspotPortal}/${env.hubspot_enterprise_id}`;
export const hubspotBrokerURL = hubspot + `${hubspotPortal}/${env.hubspot_broker_id}`;

export const HOSTNAME = 'theguarantors.com';

export const externalLinks = {
  accountCreationAccessTerms:
    'https://www.theguarantors.com/account-creation-access-terms?hsLang=en',
  privacy: 'https://www.theguarantors.com/privacy?hsLang=en',
  terms: 'https://www.theguarantors.com/terms?hsLang=en',
  // TransUnion-specific links
  tuNoticeOfCollection: 'https://www.theguarantors.com/tu-notice-of-collection?hsLang=en',
  tuPrivacy: 'https://www.theguarantors.com/tu-privacy?hsLang=en',
  tuAccountCreationAccessTerms:
    'https://www.theguarantors.com/tu-account-creation-access-terms?hsLang=en',
  tuTerms: 'https://www.theguarantors.com/tu-terms?hsLang=en',
  tuLegalRegulatory: 'https://www.theguarantors.com/tu-legal-regulatory?hsLang=en',

  legalRegulatory: 'https://www.theguarantors.com/legal-regulatory?hsLang=en',
  landLordhelpCenter: 'https://www.theguarantors.com/landlords-help-center',
  helpEmail: 'landlord@theguarantors.com', // ignore this
  faq: 'https://www.theguarantors.com/enroll-property#faq',
  operatorsFAQ: 'https://www.theguarantors.com/faq-for-operators',
  renterFAQ: 'https://www.theguarantors.com/renter-invite#faq',
  renterApplication: 'https://qualify.theguarantors.com/renters',
  noticeCollection: 'https://www.theguarantors.com/notice-of-collection',
  gettingStarted: 'https://www.theguarantors.com/get-started',
  submitClaim: 'https://www.theguarantors.com/submit-a-claim',
  LandingPageSMB: 'https://www.theguarantors.com/enroll-property', // SMB Landing page
  homePage: 'https://www.theguarantors.com', // TG Landing page
  ownersAndOperators: 'https://www.theguarantors.com/operators',
  ownersContactPage: 'https://www.theguarantors.com/contact-us',
  gettingStartedFlow: 'https://www.theguarantors.com/get-started/operators/step-1',
  newSmbUserLearnMore: 'https://www.theguarantors.com/landlords/help-center/enroll-a-property',
  bCorpCertification:
    'https://www.theguarantors.com/blog/company-updates/theguarantors-announces-b-corp-certification',
  trustCenter: 'https://trust.theguarantors.com/',
};

export const externalTitles = {
  privacy: 'Privacy Policy',
  terms: 'Terms of Service',
  legalRegulatory: 'Legal/Regulatory Notice',
  helpEmail: 'Help Email',
  faq: 'FAQ',
  noticeCollection: 'Notice of Collection',
  trustCenter: 'Trust Center',
  // TransUnion-specific titles
  tuNoticeOfCollection: 'TransUnion Notice of Collection',
  tuPrivacy: 'TransUnion Privacy Policy',
  tuAccountCreationAccessTerms: 'TransUnion Account Creation & Access Terms',
};

export const footerMenu = [
  {
    title: externalTitles.privacy,
    to: externalLinks.privacy,
  },
  {
    title: externalTitles.terms,
    to: externalLinks.terms,
  },

  {
    title: externalTitles.legalRegulatory,
    to: externalLinks.legalRegulatory,
  },
  {
    title: externalTitles.noticeCollection,
    to: externalLinks.noticeCollection,
  },
  {
    title: externalTitles.trustCenter,
    to: externalLinks.trustCenter,
  },
];

export const SocialLinks = [
  {
    icon: <LinkedInIcon aria-label="LinkedIn" aria-hidden="false" height="30" width="30" />,
    link: 'https://www.linkedin.com/company/the-guarantors',
  },
  {
    icon: <XIcon aria-label="Twitter" aria-hidden="false" height={18} width={18} />,
    link: 'https://twitter.com/The_Guarantors',
  },
  {
    icon: <IconFacebook width={20} height={21} />,
    link: 'https://www.facebook.com/TheGuarantors',
  },
  {
    icon: <InstagramIcon aria-label="Instagram" aria-hidden="false" height={18} width={18} />,
    link: 'https://www.instagram.com/theguarantors',
  },
  {
    icon: <WechatIcon aria-label="WeChat" aria-hidden="false" height={18} width={21} />,
    link: 'https://www.theguarantors.com/wechat',
  },
];

export const text = [
  {
    header: 'Approved',
    text: 'This renter is low risk (good credit profile, solid rental history, etc). Selecting “approved” for this type of applicant will invite them to purchase a one month security deposit replacement.',
  },
  {
    header: 'Conditional',
    text: 'This renter is medium risk (perhaps due to a credit dip, unstable income, etc). Selecting “conditionally approved” for this type of applicant will invite them to purchase a policy for five months of lease coverage and a one month security deposit replacement.',
  },
  {
    header: 'Denied',
    text: 'This renter is high risk (may nave no credit, limited income, etc). Selecting “denied” for this type of applicant will invite them to purchase a policy for eleven months of lease coverage and a one month security deposit replacement.',
  },
];

export const UTM_CODES = [
  'utm_adgroup',
  'utm_campaign',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_term',
] as const;

export type UserStatus = {
  isNewSelfServiceUser: boolean;
  hasProperties: boolean;
  isAccountAdmin: boolean;
  newSMBNotification?: string;
};

export const EMAIL_ADDRESSES = {
  LEASING: 'leasing@theguarantors.com',
  LANDLORD: 'landlord@theguarantors.com',
  CLAIMS: 'claims@theguarantors.com',
  RI_PM: 'ri.pm@theguarantors.com',
} as const;

export const APPLICATION_STATUS_TOOLTIP_CONTENT = {
  landlordActionNeeded: (
    <span>
      Please review the provided lease details. To make an update, email{' '}
      <a
        href={`mailto:${EMAIL_ADDRESSES.LEASING}`}
        style={{ textDecoration: 'underline', color: 'inherit' }}
      >
        {EMAIL_ADDRESSES.LEASING}
      </a>
    </span>
  ),
  applicationDenied: (
    <span>
      Unfortunately, this application wasn’t approved. Possible reasons include, but are not limited
      to, credit score, credit history, recent financial history, or other information disclosed in
      the application process.
    </span>
  ),
  editLeaseDetails: <span>Edit details now</span>,
} as const;

export const CLAIMS_SUBMISSION_TOOLTIP_CONTENT = {
  evictionFiling: (
    <span>
      Complaint, petition, or other court filing that shows the date the case was started.
    </span>
  ),
  newEvictionFilingCopy: (
    <span>Complaint, petition, or other court filing that shows the date the case was filed.</span>
  ),
  proofOfRelisting: (
    <span>
      Proof of re-listing can include your website, a commercial site, or a show sheet that lists
      the unit as available.
    </span>
  ),
  uploadFinalizedLedger: (
    <span>
      A record of all charges (e.g. rent charges, payments received, dates, payment methods, and any
      outstanding balances, along with other charges like late fees or utility bills).
    </span>
  ),
} as const;
